import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { LayoutService } from '../../../../../_rms';
import { StatesService } from 'src/app/_rms/services/states/states.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-aside-internal',
  templateUrl: './aside-internal.component.html',
  styleUrls: ['./aside-internal.component.scss'],
})
export class AsideInternalComponent implements OnInit {
  disableAsideSelfDisplay: boolean;
  headerLogo: string;
  brandSkin: string;
  ulCSSClasses: string;
  location: Location;
  asideMenuHTMLAttributes: any = {};
  asideMenuCSSClasses: string;
  asideMenuDropdown;
  brandClasses: string;
  asideMenuScroll = 1;
  asideSelfMinimizeToggle = false;
  menuSelected: string = 'dashboard';
  isBrowsing: boolean = true;
  isOrgIdValid: boolean = false;
  isManager: boolean = false;

  constructor(private statesService: StatesService,
              private layout: LayoutService, 
              private loc: Location,
              private router: Router) { }

  ngOnInit(): void {
    const orgId = this.statesService.currentAuthOrgId;
    this.isBrowsing = this.router.url.includes('browsing') ? true : false;
    this.isManager = this.statesService.isManager();
    this.isOrgIdValid = this.statesService.isOrgIdValid();

    // load view settings
    this.disableAsideSelfDisplay =
      this.layout.getProp('aside.self.display') === false;
    this.brandSkin = this.layout.getProp('brand.self.theme');
    this.headerLogo = this.getLogo();
    this.ulCSSClasses = this.layout.getProp('aside_menu_nav');
    this.asideMenuCSSClasses = this.layout.getStringCSSClasses('aside_menu');
    this.asideMenuHTMLAttributes = this.layout.getHTMLAttributes('aside_menu');
    this.asideMenuDropdown = this.layout.getProp('aside.menu.dropdown') ? '1' : '0';
    this.brandClasses = this.layout.getProp('brand');
    this.asideSelfMinimizeToggle = this.layout.getProp(
      'aside.self.minimize.toggle'
    );
    this.asideMenuScroll = this.layout.getProp('aside.menu.scroll') ? 1 : 0;
    // this.asideMenuCSSClasses = `${this.asideMenuCSSClasses} ${this.asideMenuScroll === 1 ? 'scroll my-4 ps ps--active-y' : ''}`;
    // Routing
    this.location = this.loc;
  }

  private getLogo() {
    if (this.brandSkin === 'light') {
      return './assets/media/logos/logo-dark.png';
    } else {
      return './assets/media/logos/logo-light.png';
    }
  }
}
